import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { Router } from '@angular/router';

@Component({
  selector: 'sign-out-dialog',
  templateUrl: '../sharedTemplates/sign-out.dialog.html',
})
export class SignOutDialog {
  constructor(
    public dialogRef: MatDialogRef<SignOutDialog>,
    private _ApiService: ApiService,
    private _UserHelper: UserHelper,
    private _router: Router,
    private _UiHelper: UiHelper
  ) {}
  isLoading = false;

  signOutNoClick(): void {
    this.dialogRef.close();
  }

  signOutYesClick(): void {
    if (this.isLoading === true) {
      return;
    }
    this.isLoading = true;
    this._ApiService
      .signOut()
      .then(result => {
        setTimeout(() => {
          this.isLoading = false;
          this._UserHelper.userLogOut();
          this._router.navigate(['/home']);
          this.dialogRef.close();
          this._UiHelper.setRefreshApp();
        }, 1000);
      })
      .catch(err => {
        this.isLoading = false;
        console.log('sign-out.dialog', err);
      });
  }
}
